/**
 * A read that can't hang: each try gets `ms` to answer and a stalled or
 * failed one is tried again, up to `attempts` times. Firestore's getDoc can
 * wait indefinitely while its connection is stuck (CI saw sign-in sit on
 * "Verifying authentication..." past 30 s); a fresh try usually answers.
 * Rejects with the last failure when every try fails.
 */
export async function readWithRetries<T>(read: () => Promise<T>, { attempts = 3, ms = 10000 } = {}): Promise<T> {
  let last: unknown;
  for (let i = 0; i < attempts; i++) {
    let timer: ReturnType<typeof setTimeout> | undefined;
    try {
      return await Promise.race([
        read(),
        new Promise<never>((_, reject) => {
          timer = setTimeout(() => reject(new Error(`No answer in ${ms} ms`)), ms);
        }),
      ]);
    } catch (e) {
      last = e;
    } finally {
      clearTimeout(timer);
    }
  }
  throw last;
}
